import React from 'react';

function ToggleSwitch({ label, defaultChecked, onChange }) {
    return (
        <div className="flex items-center">
            <span className="mr-4">{label}</span>
            <div className="relative inline-block w-10 h-5 align-middle select-none">
                <input
                    id={`toggle-switch-${label}`}
                    type="checkbox"
                    defaultChecked={defaultChecked}
                    onChange={onChange}
                    className="hidden peer" // Hide the default checkbox
                />
                <label
                    htmlFor={`toggle-switch-${label}`}
                    className={`block w-10 h-5 rounded-full cursor-pointer transition-colors duration-200 ease-in-out
                            ${defaultChecked ? 'bg-green-500' : 'bg-gray-200'}`}
                >
                    {/* Toggle circle */}
                    <span
                        className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow-sm transform transition-transform duration-200 ease-in-out
                                ${defaultChecked ? 'translate-x-5' : 'translate-x-0'}`}
                    />
                </label>
            </div>
        </div>
    );
}

export default ToggleSwitch;

// import React from 'react';
//
// function ToggleSwitch({ label, defaultChecked, onChange }) {
//     return (
//         <div className="flex items-center">
//             <span className="mr-4">{label}</span>
//             <div className="relative inline-block w-10 align-middle select-none">
//                 <input
//                     id={`toggle-switch-${label}`}
//                     type="checkbox"
//                     defaultChecked={defaultChecked}
//                     onChange={onChange}
//                     className={`peer absolute block w-4 h-4 rounded-full bg-white border-4 appearance-none cursor-pointer
//                             transition-transform duration-200 ease-in-out translate-x-0 peer-checked:translate-x-6
//                             ${defaultChecked ? 'translate-x-5' : 'translate-x-0'}`}
//                     style={{
//                         top: '2px',
//                         left: '2px',
//                         borderColor: defaultChecked ? '#22C55E' : '#D1D5DB'
//                 }}
//                 />
//                 <label
//                     htmlFor = {`toggle-switch-${label}`}
//                     className={`block overflow-hidden h-5 rounded-full cursor-pointer transition-colors duration-200 ease-in-out
//                             ${defaultChecked ? 'bg-green-500' : 'bg-gray-200'}`}
//                 />
//             </div>
//         </div>
//     );
// }
//
// export default ToggleSwitch;